export default class ScenarioToUploadObject {
  constructor(id, name, humanName, path, toggledForUpload = false) {
    this.id = Number(id);
    this.name = String(name);
    this.humanName = String(humanName);
    this.path = String(path);
    this.toggledForUpload = Boolean(toggledForUpload);
    this.hasError = Boolean(false);
    this.hasUploaded = Boolean(false);
    this.errorMessage = String("");
  }
  static toJSON() {
    id: this.id;
    name: this.name;
    path: this.path;
    toggled_for_upload: this.toggledForUpload;
    has_errors: this.hasErrors;
    has_uploaded: this.hasUploaded;
    error_message: this.errorMessage;
  }
}
